import React from 'react';
import './HowToUse.css';

const HowToUse = () => {
  const steps = [
    {
      number: '1',
      title: 'Téléchargez l\'application',
      description: 'Téléchargez Shini Pay depuis le <a href="https://play.google.com/store/apps/details?id=com.djammadev.shiniwari" target="_blank">Google Play Store</a> ou l\'<a href="https://apps.apple.com/app/shinipay/id6755893262" target="_blank">App Store</a> sur votre smartphone.',
      screenshot: null,
    },
    {
      number: '2',
      title: 'Connectez-vous à votre compte',
      description: 'Connectez-vous à votre compte avec votre numéro de téléphone ou votre email et votre mot de passe.',
      screenshot: '/screenshots/login-1.PNG',
    },
    {
      number: '3',
      title: 'Rechargez votre compte',
      description: 'Rechargez votre compte en utilisant Orange Money, Sama Money, Stripe ou un code de recharge.',
      screenshot: '/screenshots/topup-1.PNG',
    },
    {
      number: '4',
      title: 'Commencez à utiliser',
      description: 'Rechargez votre compte, gérez vos cartes et consultez votre historique de transactions.',
      screenshot: '/screenshots/home-1.PNG',
    },
  ];

  return (
    <section id="how-to-use" className="how-to-use">
      <div className="container">
        <h2 className="section-title">Comment utiliser</h2>
        <p className="section-subtitle">
          Suivez ces étapes simples pour commencer à utiliser Shini Pay
        </p>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description"><span dangerouslySetInnerHTML={{ __html: step.description }} /></p>
                {step.screenshot && (
                  <div className="step-screenshot">
                    <img 
                      src={step.screenshot} 
                      alt={step.title}
                      className="step-image"
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToUse;

